import {useEffect} from "react";

const useScrollLock = (locked: boolean) => {
    useEffect(() => {
        const scrollElement = document.scrollingElement;
        if (!(scrollElement instanceof HTMLElement)) {
            return;
        }

        const initialOverflow = getComputedStyle(scrollElement).overflow;

        if (locked) {
            scrollElement.style.overflow = 'hidden';
        } else {
            scrollElement.style.overflow = initialOverflow;
        }

        return () => {
            scrollElement.style.overflow = initialOverflow;
        };
    });
};

export default useScrollLock;
